export const OFFER_CARD_PATH_REGEX = /\/(sale|rent)\/(flat|suburban|commercial)\/\d/;
